import { all } from './Actions/all';
import { create } from './Actions/create';
import { edit } from './Actions/edit';
import { editImage } from './Actions/editImage';
import { editRound } from './Actions/editRound';
import { get } from './Actions/get';
import { getDetailGames } from './Actions/getDetailGames';
import { getRound } from './Actions/getRound';
import { createFlight } from './Actions/createFlight';
import { editFlight } from './Actions/editFlight';
import { setCurrent } from './Actions/setCurrent';
import { removeFlight } from './Actions/removeFlight';
import { TActionsWithoutState } from '../../Interfaces/TActionsWithoutState';

const actions = {
  all,
  create,
  createFlight,
  edit,
  editFlight,
  editImage,
  editRound,
  get,
  getDetailGames,
  getRound,
  removeFlight,
  setCurrent
};

export type IAdminEventActions = TActionsWithoutState<typeof actions>;

export default actions;
